/* Editable labels/titles for each section of the landing page.
   Shared by the public Home page (reads them) and Admin Settings (edits them).
   Kept in its own module so the public bundle doesn't pull in admin code. */

export const LABEL_DEFAULTS = {
  heroStatus: 'On Air',
  heroRole: 'Senior Journalist',
  aboutKicker: 'About',
  aboutTitle: 'Who she is',
  experienceKicker: 'Experience',
  experienceTitle: 'The timeline',
  workKicker: 'Published Bylines',
  workTitle: 'In print & online',
  reelsKicker: 'Social Reels',
  reelsTitle: 'Work in motion',
};

/* Admin form grouping — [key, sub-label] pairs under a heading. */
export const LABEL_GROUPS = [
  { heading: 'Hero', fields: [
    ['heroStatus', 'Status pill (small)'],
    ['heroRole', 'Role line'],
  ] },
  { heading: 'Experience section', fields: [
    ['experienceKicker', 'Kicker (small label)'],
    ['experienceTitle', 'Title'],
  ] },
  { heading: 'Published bylines section', fields: [
    ['workKicker', 'Kicker (small label)'],
    ['workTitle', 'Title'],
  ] },
  { heading: 'Reels section', fields: [
    ['reelsKicker', 'Kicker (small label)'],
    ['reelsTitle', 'Title'],
  ] },
];
